import React, { useState } from 'react';

import { BaseFiltersPanel } from '../../Paylinks/components/BaseFiltersPanel';
import {
  AuditLogFiltersFormValues,
  auditLogFiltersEmptyValues,
  useAuditLogFiltersForm,
} from '../../../hooks/useAuditLogFiltersForm';
import { GetAuditLogsQueryFilters } from '../../../store/modules/merchant/types';
import { AuditLogFilters } from './AuditLogFilters';

const convertToQueryFilters = (data: AuditLogFiltersFormValues): GetAuditLogsQueryFilters => {
  const filters: GetAuditLogsQueryFilters = {};

  if (data.resources.length > 0) filters.resources = data.resources;
  if (data.createdAfter?.isValid()) filters.createdAfter = data.createdAfter.toISOString();
  if (data.createdBefore?.isValid()) filters.createdBefore = data.createdBefore.toISOString();

  return filters;
};

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onFiltersApply: (filters: GetAuditLogsQueryFilters) => void;
  initialFilterState?: Partial<AuditLogFiltersFormValues>;
}

export const AuditLogFiltersPanel = ({
  isOpen,
  onClose,
  onFiltersApply,
  initialFilterState = {},
}: Props) => {
  const [lastApplied, setLastApplied] = useState({
    ...auditLogFiltersEmptyValues,
    ...initialFilterState,
  });

  const {
    control,
    formState: { errors },
    setValue,
    watch,
    reset,
    handleSubmit,
  } = useAuditLogFiltersForm({
    initialValues: initialFilterState,
  });

  const onSubmit = (data: AuditLogFiltersFormValues) => {
    onFiltersApply(convertToQueryFilters(data));
    setLastApplied(data);
    onClose();
  };

  const onCancel = () => {
    reset(lastApplied);
    onClose();
  };

  return (
    <BaseFiltersPanel
      isOpen={isOpen}
      onCancel={onCancel}
      onReset={() => reset(auditLogFiltersEmptyValues)}
      onSubmit={handleSubmit(onSubmit)}
      filtersCount={Object.keys(convertToQueryFilters(watch())).length}
    >
      <AuditLogFilters
        hookFormProps={{
          watch,
          setValue,
          control,
          errors,
        }}
      />
    </BaseFiltersPanel>
  );
};
